import { format } from 'date-fns';

/* Formats the date presented in a component as "Month-name, day, 4 digit year". For example,
2023-01-13 will be displayed as "January 13th, 2023." */
export const formatDate = (date: Date) => format(date, "MMMM dd, yyyy");

/* Formats the date presented in a component as "Short-month-name, day, 4 digit year". For example,
2023-01-13 will be displayed as "Jan 13th, 2023." */
export const formatShortDate = (date: Date) => format(date, 'MMM dd, yyyy')

/* Formats the date presented in a component as '9999-99-99' in Year - month -day. */
export const formatfileNameDate = (date: Date) => format(date, "yyyy-MM-dd");

/* Formats the amount presented in a component as United States dollar currency. For example 
    30.23 will be displayed "$30.23.""
   -30.23 will be displayed as "-$30.23."" 
 */
export const formatMoney = (amount: number) =>  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
}).format(amount);

export const removeLeadingZeros = (str: string|undefined) => {
    if (!str) return '';
    return str.replace(/^0+/, '');
};

export const formatDecimalNumber = (num: number, decimalCases: number) => {
    if (isNaN(num)) {
        return 0;
    }
    return num.toFixed(decimalCases)
};